import { commonServerInstance, downloadInstance } from '@/utilities/instances'
import { downloadFile } from './common'

export interface ISearchFleetBillingList {
  warehouse?: string
  team_id?: string
  dsp_id?: string
  stat_date_from?: string
  stat_date_to?: string
  page?: number
  per_page?: number
}

export const fetchFleetBillingList = async (
  params: ISearchFleetBillingList
) => {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, v]) => v !== undefined && v !== null && v !== ''
    )
  )
  const response = await commonServerInstance.post(
    'api/v1/dsp/fleet-billing/search',
    filteredParams
  )
  return response?.data?.data
}

// 全量warehouse list
export const fetchWarehouseList = async () => {
  const response = await commonServerInstance.get(
    'api/v1/dsp/fleet-billing/options/warehouses'
  )
  return response?.data?.data
}

// 当前billing的warehouse list
export const fetchFleetBillingWarehouseList = async (id: string) => {
  const response = await commonServerInstance.get(
    `/api/v1/dsp/fleet-billing/${id}/options/warehouses`
  )
  return response?.data?.data
}

export const fetchFleetBillingStatusList: () => Promise<
  Array<'draft' | 'approved' | 'rejected' | 'submitted'>
> = async () => {
  const response = await commonServerInstance.get(
    '/api/v1/dsp/options/approval-statuses'
  )
  return response?.data?.data
}

// 全量teams list
export const fetchTeamsList = async () => {
  const response = await commonServerInstance.get(
    '/api/v1/dsp/fleet-billing/options/teams'
  )
  return response?.data?.data
}

// 当前billing的teams list
export const fetchFleetTeamsList = async (id: string) => {
  const response = await commonServerInstance.get(
    `/api/v1/dsp/fleet-billing/${id}/options/teams`
  )
  return response?.data?.data
}

// 全量drivers list
export const fetchDriversList = async () => {
  const response = await commonServerInstance.get(
    '/api/v1/dsp/fleet-billing/options/drivers'
  )
  return response?.data?.data
}

// 当前billing的drivers list
export const fetchFleetDriversList = async (id: string) => {
  const response = await commonServerInstance.get(
    `/api/v1/dsp/fleet-billing/${id}/options/drivers`
  )
  return response?.data?.data
}

export const fetchFleetBillingDetail = async (id: string) => {
  const response = await commonServerInstance.get(
    `/api/v1/dsp/fleet-billing/${id}`
  )
  return response?.data?.data
}

export const fetchFleetTeamReport = async (id: string, params: any) => {
  const response = await commonServerInstance.post(
    `/api/v1/dsp/fleet-billing/${id}/team-report`,
    params
  )
  return response?.data?.data
}

export const fetchFleetDriverReport = async (id: string, params: any) => {
  const response = await commonServerInstance.post(
    `/api/v1/dsp/fleet-billing/${id}/driver-report`,
    params
  )
  return response?.data?.data
}

export const fetchFleetDriverDaily = async (id: string, params: any) => {
  const response = await commonServerInstance.post(
    `/api/v1/dsp/fleet-billing/${id}/driver-daily`,
    params
  )
  return response?.data?.data
}

export const fetchFleetAdjustmentDetail = async (id: string, params: any) => {
  const response = await commonServerInstance.post(
    `/api/v1/dsp/fleet-billing/${id}/adjustment-detail`,
    params
  )
  return response?.data?.data
}

export const fetchFleetAdjustmentDetailPickup = async (
  id: string,
  params: any
) => {
  const response = await commonServerInstance.post(
    `/api/v1/dsp/fleet-billing/${id}/adjustment-detail-pickup`,
    params
  )
  return response?.data?.data
}

export const fetchFleetDeliveryFeeDetail = async (id: string, params: any) => {
  const response = await commonServerInstance.post(
    `/api/v1/dsp/fleet-billing/${id}/delivery-fee-detail`,
    params
  )
  return response?.data?.data
}

export const downloadFleetBilling = async (id: string) => {
  const response = await downloadInstance.get(
    `api/v1/dsp/fleet-billing/${id}/download`,
    {
      responseType: 'blob'
    }
  )
  return await downloadFile(response)
}

export const bulkDownloadFleetBilling = async (params: {
  fleet_billing_ids: number[]
}) => {
  const response = await downloadInstance.post(
    `api/v1/dsp/fleet-billing/bulk-download`,
    params,
    {
      responseType: 'blob'
    }
  )
  return await downloadFile(response)
}

export const approveFleetBilling = async (params: { model_id: string }) => {
  const response = await commonServerInstance.post(
    `api/v1/approval/process/model-approve`,
    {
      model_type: 'fleet_billing',
      ...params
    }
  )
  return response?.data?.data
}

export const rejectFleetBilling = async (params: {
  model_id: string
  comment: string
}) => {
  const response = await commonServerInstance.post(
    `api/v1/approval/process/model-decline`,
    {
      model_type: 'fleet_billing',
      ...params
    }
  )
  return response?.data?.data
}

export const fetchDSPBillingPeriodList = async () => {
  const response = await commonServerInstance.get(
    '/api/v1/dsp/options/billing-periods'
  )
  return response?.data?.data
}

// Batch approve fleet billing
export const batchApproveFleetBilling = async (params: {
  model_ids: string
  warehouse_id?: string
  status?: string
  billing_period?: any
}) => {
  const response = await commonServerInstance.post(
    `api/v1/approval/process/batch-model-approve`,
    {
      model_type: 'fleet_billing',
      ...params
    }
  )
  return response?.data?.data
}

// Batch reject fleet billing
export const batchRejectFleetBilling = async (params: {
  model_ids: string
  comment: string
  warehouse_id?: string
  status?: string
  billing_period?: any
}) => {
  const response = await commonServerInstance.post(
    `api/v1/approval/process/batch-model-decline`,
    {
      model_type: 'fleet_billing',
      ...params
    }
  )
  return response?.data?.data
}

export const fetchFleetBillingDSPList = async () => {
  const response = await commonServerInstance.get(
    `api/v1/dsp/fleet-billing/options/dsps`
  )
  return response?.data?.data
}

// 全量stat date list
export const fetchFleetBillingStatDateList = async (): Promise<string[]> => {
  const response = await commonServerInstance.get(
    'api/v1/dsp/fleet-billing/options/stat-dates'
  )
  return response?.data?.data
}

export const previewFleetBillingEmail = async (params: {
  fleet_billing_ids: number[]
}) => {
  const response = await commonServerInstance.post(
    'api/v1/dsp/fleet-billing/send/preview',
    params
  )
  return response?.data?.data
}

export const sendFleetBillingEmail = async (params: {
  fleet_billing_ids: number[]
  confirmed: boolean
}) => {
  const response = await commonServerInstance.post(
    'api/v1/dsp/fleet-billing/send',
    params
  )
  return response?.data?.data
}
